import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Typography } from "@mui/material";

const Footer = ({ componentFlag }) => {
  const classes = useStyles({ componentFlag });

  return (
    <footer className={classes.root}>
      <Box>
        {/* <Typography className={classes.textStyle} style={{color: componentFlag==="dashboard" ? "black" : "white"}}>
          Designed and developed by
          <a className={classes.linkStyles} href={`https://codeavenir.com/`} style={{color: componentFlag==="dashboard" ? "black" : "white"}}>
            Code Avenir
          </a>
        </Typography> */}
      </Box>
    </footer>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "100vw",
    height: "8vh",
    // background: "blue",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // maxWidth: "1400px",
  },
  linkStyles: {
    textDecoration: "none",
    marginLeft: 5,
    // color: (props) => (props.componentFlag === "dashboard" ? "black" : "white"),
    color: "white",
  },
  textStyle: {
    color: (props) => (props.componentFlag === "dashboard" ? "black" : "white"),
  },
}));

export default Footer;
